import type { FaireProductEntity } from "../../entity_types/product";

export const p_4v9244fwdr: FaireProductEntity = {
  token: "p_4v9244fwdr",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Initial Necklace",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/19dcfc49936769a2c2ac69eeda20906514ce5c7c69cbb2dd9f4c8a840c1c539d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b16104a2738f29e3e22ac3e1778979a1d35841a056ff508600d1441a712f4c4d.jpeg",
    "https://cdn.faire.com/fastly/51a8f73b19a808a4a7199e4e961d474aa234af03f130e7792e41394587716ae7.jpeg",
    "https://cdn.faire.com/fastly/e181688613568d16b71ee14830e23f9e069782d6367c5ccce1fef9b5f47e0ce1.jpeg",
    "https://cdn.faire.com/fastly/cef710b36c141d9993e4137f95510e88e2bf46632d5f54f9000f143c100eb3e2.jpeg",
    "https://cdn.faire.com/fastly/63fd2a26855e5bcbfa5849967fa15e1fdd595d762be9ce6daf5f8923cca8f67d.jpeg",
    "https://cdn.faire.com/fastly/da3fe653486c710c9ac8f16383dde0d300d9b843e40badfac4461c429a3c43f9.jpeg",
    "https://cdn.faire.com/fastly/b09fa8fe5a887be8365bf34b1bd5838af83ce883f92a3f687bd94cf3739270ae.jpeg",
    "https://cdn.faire.com/fastly/90caff3c603e8090ef3d8c64bc491d860a9cf123a90112c69543d817546ea011.jpeg",
    "https://cdn.faire.com/fastly/55ff72114dc02be913677760683c6d1ddc0298ff5c78954d354422251afb3c96.jpeg",
    "https://cdn.faire.com/fastly/f399404f37cf52fc090fe94ee92bb320c469e8ab0282a62a8151a8351abfd391.jpeg",
    "https://cdn.faire.com/fastly/92d7e699c388dd5ada6e9a7c83aa8d106188bc6f0e259bc7a8eaeeeb7122b320.jpeg",
    "https://cdn.faire.com/fastly/57b3dab05ba57677bab6fde885c17097770fe44786052275525ef9a952cbad86.jpeg",
    "https://cdn.faire.com/fastly/d9f4ddbd24dc04140f7378562fc7b07ed88a0d82131ffae00116ab495b329cc7.jpeg",
  ],
  priceDollars: 4.71,
  description:
    'Dainty Stainless Steel Sideways Initial Necklace.\nApprox. 16" L plus extender.\nApprox. 0.5 inch letter.\n\n\n\nThis item is hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n',
  tags: [],
  msrpDollars: 18.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:57.391Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
